<!-- A wrapper around BaseParagraph, but with out own paragraph text color by default. -->
<script setup lang="ts">
// TODO: this sucks. Need to rethink this.

const { color } = defineProps<{
  color?: 'normal' | 'light' | 'on-colored-background'
}>()
</script>

<template>
  <BaseParagraph
    :class="{
      'text-primary-500 dark:text-primary-300':
        color == 'on-colored-background',
      'text-muted-700 dark:text-muted-400': color == 'normal',
      'text-muted-500 dark:text-muted-400': color == 'light',
    }"
  >
    <slot />
  </BaseParagraph>
</template>
